import { render, staticRenderFns } from "./package-status-cashier.vue?vue&type=template&id=31c761b2"
import script from "./package-status-cashier.vue?vue&type=script&lang=js"
export * from "./package-status-cashier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports